import GarrisonContent from "./garrison-content.jsx";
import ObservationContent from "./observation-content.jsx";
import React from "react";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ActivityContent = ({ data, boName, showDetails }) => {
    const navigate = navigateHook();

    return (
        <>
            <table className="journal-table table">
                <tbody style={{borderBottom: `${data.length > 1 ? '1px solid #e7eaec' : ''}`}} className={'bg-white'}>
                    <tr>
                        <th colSpan={12} className="text-center main-divisor-header">
                            <a onClick={() => navigate(`/despacho/activity/form/${data?.id}`, true)} className={'journal-important-link'}>
                                Plantão {data?.onduty}
                            </a>
                        </th>
                    </tr>

                    <GarrisonContent garrisonData={data?.garrisonData} inspector={data?.inspector} updatedUser={data?.updatedUser} boName={boName} showDetails={showDetails}/>
                    <ObservationContent observation={data?.observation}/>
                </tbody>
            </table>

            <div id="chart-tables"></div>
        </>
    );
};

export default ActivityContent;
